import type { Deal } from "@/api/client";
import { Field } from "@/components/deals/DealProfileSections";
import { SectionHeading } from "@/components/ui/section";
import { CHANNEL_PARTNER, CHANNEL_PARTNER_DETAILS, DEAL_OWNER } from "@/lib/role-labels";

/**
 * The "Channel Partner Details" sub-section of "The Deal" — manager (CM/RA/RM)
 * views (CHP-241/243/245/246), reused across all three review screens
 * (registration, extension, closed-won) and the detail view.
 *
 * CHP-400: the block is stacked (single column) rather than spread across
 * rows — partner organisation, then the deal owner (lead BDM/PO with role),
 * then the owner's contact details (phone first, then email — CHP-378). The
 * sub-headers are "Channel Partner", "Deal Owner", "Phone", "E-mail". Fields
 * are populated by GET /deals/{id}.
 */
export function ChannelPartnerSection({ deal }: { deal: Deal }) {
  const dealOwner =
    deal.lead_bdm_name && deal.lead_bdm_role
      ? `${deal.lead_bdm_name} (${deal.lead_bdm_role})`
      : (deal.lead_bdm_name ?? "—");
  return (
    <section>
      <SectionHeading className="mb-3">{CHANNEL_PARTNER_DETAILS}</SectionHeading>
      <dl className="grid gap-3">
        <Field label={CHANNEL_PARTNER} value={deal.channel_partner_company ?? "—"} />
        <Field label={DEAL_OWNER} value={dealOwner} />
        {/* CHP-378: owner contact — phone first, email second. */}
        <Field label="Phone" value={deal.lead_bdm_phone ?? "—"} />
        <Field label="E-mail" value={deal.lead_bdm_email ?? "—"} />
      </dl>
    </section>
  );
}
